export const NAVIGATION_KEYS = {
  ORGANIZATIONS: 'Organizations',
  USERS: 'Users',
  JOBS: 'Jobs',
  VERSIONS: 'Versions',
  OVERVIEW: 'Overview',
  AUDIT_LOGS: 'Audit Logs',
  DISCOVERY_CYCLES: 'Discovery Cycles',
  ORGANIZATION_CONFIGURATION: 'Organization Configuration',
  CLIENT_CONFIGURATIONS: 'Client Configurations',
  CLIENT_CONFIGURATION: 'Client Configuration',
  CLIENTS: 'Clients',
  CASES: 'Cases',
  CASE: 'Case',
  CASE_FILES: 'Case Files',
  INTAKES: 'Intakes',
  INTAKE: 'Intake',
  INTAKE_FILES: 'Intake Files',
  PROVIDERS: 'Providers',
  PROVIDER: 'Provider',
  PROVIDER_FILES: 'Provider Files',
  TEMPLATES: 'Templates',
  TEMPLATE: 'Template',
  TEMPLATE_FILES: 'Template Files',
  FIRM_DOCUMENTS_FOLDERS: 'Firm Documents Folders',
  FIRM_DOCUMENTS_FOLDER: 'Firm Documents Folder',
  FIRM_DOCUMENTS: 'Firm Documents',
  FLAGGED_PATHS: 'Flagged Paths',
  RENAMED_FOLDERS: 'Renamed Folders',
  SOURCE_LINKS: 'Source Links',
  EXECUTE_SQL_SCRIPTS: 'Execute SQL Scripts',
  RECALCULATE_FILE_PRIORITIES: 'Refresh Files Migration Queue',
  BULK_DELETE: 'Bulk Delete',
  RESOLVE_CONFLICTS_BY_RULE: 'Resolve Conflicts by Rule',
  DOCS: 'Docs'
} as const;